/** The facts about a tile of the predicted view at the predicted time, or about the one under me. */
import type { Game } from '../game';
import { predictTime } from '../session/predict';
import { tileFacts, type TileFacts } from './tile';

/** The facts about `tile`; null without a planet. */
export function factsAt(game: Game, tile: number): TileFacts | null {
  const s = game.store.get();
  if (!s.view || tile < 0) return null;
  return tileFacts(s.view, tile, predictTime(game));
}

/** The facts about the tile under me, or null while I'm not on the planet. */
export const factsHere = (game: Game): TileFacts | null => factsAt(game, game.store.get().here);
